module.exports = __webpack_public_path__ + "static/media/monument_img_2.3c7b75ab.png";